import { EmailAddressEntity } from './email-address/email-address.model';
import { ProfileEntity } from './profile/user-profile.model';
import { WalletAddressEntity } from './wallet/wallet-address.model';

export class UserEntity {
  id: string;
  emailAddress?: EmailAddressEntity;
  signInProviderId?: string;
  roles?: UserRoles;
  onboardingPhase: OnboardingPhases;
  username?: string;
  isActive: boolean;
  twoFASecret?: string;
  signInProvider?: string;
  avatar?: string;
  nft?: string;
  isSubscribed?: boolean;
  investment?: any[];
  kyc?: any;
  notificationUsers?: any[];
  project?: any[];
  createdTasks?: any[];
  assignedTasks?: any[];
  walletAddresses?: WalletAddressEntity[];
  profile?: ProfileEntity;
  createdAt: Date;
  updatedAt: Date;
}

export type UserRoles = ['MEMBER' | 'PROJECT_OWNER' | 'SUPER_ADMIN' | 'ADMIN'];

export enum OnboardingPhases {
  SIGNUP = 'SIGNUP',
  USER_APPLICATION_SUBMITTED = 'USER_APPLICATION_SUBMITTED',
  ADMIN_APPROVED = 'ADMIN_APPROVED',
  KYC_APPROVED = 'KYC_APPROVED',
  MINT_NFT = 'MINT_NFT',
  DONE = 'DONE',
}
